// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uq8p","index":"styles_index__1esXq"};